import store from '@/store';

const canI = (what = null) => {
  let userRole = store.state.auth?.user?.role;
  if (userRole === 'admin') userRole = 'lab_admin';

  const access = ACCESS_PRIVILEGES[what] || null;
  if (!what || !access) throw new Error('Specify proper access string!');

  return access[userRole];
};

export default canI;

// The user can ... with role ...
export const ACCESS_PRIVILEGES = {
  seeBalance: {
    client: true,
    lab_employee: false,
    lab_admin: false,
  },
  createNewOrder: {
    client: true,
    lab_employee: false,
    lab_admin: false,
  },
  viewStats: {
    client: false,
    lab_employee: false,
    lab_admin: true,
  },
  addEmployees: {
    client: false,
    lab_employee: false,
    lab_admin: true,
  },
};
